/**
 * 图片资源集中位置
 *
 * 所有来自 readdy.ai 的 Hero 背景与学生头像占位图都在这里注册。
 * 后续替换为本地 /public 资源时，只需修改本文件。
 */

const READDY_IMG = 'https://public.readdy.ai/ai/img_res';

/** Hero/背景图 */
export const HERO_BG = {
  /** 首页 / 聊天 — 山水 */
  homeChat: `${READDY_IMG}/edited_ee86b94a32df9c8015f68ef8c68dd837_9f569bfb.jpg`,
  /** 登录启动屏（fallback） */
  splash: `${READDY_IMG}/edited_507579b936d008e3626ac114ab940d52_e4a3061d.jpg`,
  /** 登录主页（fallback） */
  login: `${READDY_IMG}/edited_609d61153cd26794465b0acfedce974b_9f569bfb.jpg`,
  /** 个人中心 */
  profile: `${READDY_IMG}/edited_eedd51d1d8b0db76d890ae4ac78d6e2a_9f569bfb.jpg`,
  /** 任务页 */
  tasks: `${READDY_IMG}/edited_79f6d771820489708180c93acf15b8b0_9f569bfb.jpg`,
} as const;

/**
 * 学生头像占位图（当学生未上传头像时使用）
 * @param size  输出尺寸（像素）
 * @param seq   缓存键（不同 seq 对应 readdy 不同种子输出，默认通用）
 */
export function studentAvatarFallback(size = 96, seq = 'student-avatar-home'): string {
  const query = encodeURIComponent(
    'young chinese student portrait, warm and friendly expression, soft watercolor illustration style, light background, gentle and studious appearance, suitable for educational app avatar, clean and simple',
  );
  return `https://readdy.ai/api/search-image?query=${query}&width=${size}&height=${size}&seq=${seq}&orientation=squarish`;
}

/** profile 默认头像：192×192 */
export const DEFAULT_STUDENT_AVATAR = studentAvatarFallback(192, 'student-avatar-default');

/**
 * 诗词大先生（AI 教师）肖像占位图
 * 聊天气泡等处使用，同一 seq 保证每次输出一致
 */
export function teacherPortrait(size = 72): string {
  const query = encodeURIComponent(
    'elegant dignified elderly Chinese female scholar and poet, gentle wise serene expression, graceful silver white hair styled neatly, wearing elegant traditional Chinese dark navy qipao, ink wash watercolor portrait illustration, warm scholarly literary atmosphere, hands holding a classical poetry book, refined and cultured appearance, oriental aesthetic, soft expressive brushstrokes, muted warm ink tones, clean light background, literary figure portrait, no text',
  );
  return `https://readdy.ai/api/search-image?query=${query}&width=${size}&height=${size}&seq=ye-jiaying-portrait-v3&orientation=squarish`;
}
